<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-four-columns>
                            <fui-column>
                                <wbo-tax-inclusive-report-criteria></wbo-tax-inclusive-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showLocationOption]="true"
                                                                     [showOutletOption]="true"
                                                                     [showTerminalOption]="true"></wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-detail-report-criteria></wbo-detail-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-checkbox-edit-control [formControlName]="'hidezero'"
                                                           [(ngModel)]="model.data.hidezero">
                                </wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-four-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
